/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import api from 'api';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import * as S from './Questionnaire.styled';

export default function Education() {
    const tableName = 'Education';
    const spouseEducation = 'SpouseEducation';
    const [dataList, setData] = useState<any>();
    const [spouseEdu, setSpouseEdu] = useState<any>();
    const params = useParams();
    const candidate_id = Number(params.id);
    useEffect(() => {
        api.tableInput.fetchCandidateInput(setData, tableName, candidate_id);
        api.tableInput.fetchCandidateInput(setSpouseEdu, spouseEducation, candidate_id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <div>
                <S.Title>Applicant</S.Title>
                {dataList?.map((data: any, index: number) => (
                    <span key={index}>
                        <S.Box>
                            <h4>Type</h4>
                            <h4>Completed</h4>
                            <S.Value>{data?.type}</S.Value>
                            <S.Value> {data?.completed ? 'Yes' : 'No'}</S.Value>
                            <h4>Field Of Study</h4>
                            <h4>Current</h4>
                            <S.Value>{data?.field_of_study}</S.Value>
                            <S.Value>{data?.current ? 'Yes' : 'No'}</S.Value>
                            <h4>Start Date</h4>
                            <h4>End Date</h4>
                            <S.Value>{data?.start?.substring(4, 17)}</S.Value>
                            <S.Value>{data?.end?.substring(4, 17)}</S.Value>
                            <h4>Country</h4>
                            <h4>Region</h4>
                            <S.Value>{data?.country}</S.Value>
                            <S.Value>{data?.region}</S.Value>
                            <h4>Institution Name</h4>
                            <h4>Grade Point average</h4>
                            <S.Value>{data?.institution_name}</S.Value>
                            <S.Value>{data?.grade_average}</S.Value>
                            <h4>Service Language</h4>
                            <h4 aria-hidden="true"></h4>
                            <S.Value>{data?.language}</S.Value>
                        </S.Box>
                    </span>
                ))}
            </div>
            <div>
                <S.Title>Spouse</S.Title>
                {spouseEdu?.map((data: any, index: number) => (
                    <span key={index}>
                        <S.Box>
                            <h4>Type</h4>
                            <h4>Completed</h4>
                            <S.Value>{data?.type}</S.Value>
                            <S.Value> {data?.completed}</S.Value>
                            <h4>Field Of Study</h4>
                            <h4>Current</h4>
                            <S.Value>{data?.field_of_study}</S.Value>
                            <S.Value>{data?.current}</S.Value>
                            <h4>Start Date</h4>
                            <h4>End Date</h4>
                            <S.Value>{data?.start.substring(4, 17)}</S.Value>
                            <S.Value>{data?.end.substring(4, 17)}</S.Value>
                            <h4>Country</h4>
                            <h4> Region </h4>
                            <S.Value>{data?.country}</S.Value>
                            <S.Value>{data?.region}</S.Value>
                        </S.Box>
                    </span>
                ))}
            </div>
        </>
    );
}
